import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { TextClasses } from '../../types';

type FlexibleHeroBlockStkBkaHeadingProps = {
  breadcrumb?: ReactNode;
  overline?: string;
  headline?: string;
  headingId?: string;
  /** Only the page-level hero owns the page's single <h1>. */
  isPageHeadline: boolean;
  /** Already formatted "Updated: …" line, when the block shows it. */
  timestamp?: string;
  textClasses: TextClasses;
  isCenter: boolean;
};

/** Breadcrumb, overline, headline and the updated date of the STK/BKA hero. */
export const FlexibleHeroBlockStkBkaHeading: FC<
  FlexibleHeroBlockStkBkaHeadingProps
> = ({
  breadcrumb,
  overline,
  headline,
  headingId,
  isPageHeadline,
  timestamp,
  textClasses,
  isCenter,
}) => {
  const HeadingTag = isPageHeadline ? 'h1' : 'div';
  const alignClasses = isCenter
    ? 'items-center text-center'
    : 'items-start text-left';

  return (
    <div
      className={classNames(
        'flex w-full flex-col gap-spacing/gap/y-sm',
        alignClasses,
      )}
      data-component="flexible-hero-block-stk-bka-heading"
    >
      {breadcrumb}

      {overline && (
        <div
          className={classNames(
            'mhg-alpha-typography-title-2',
            textClasses.overline,
          )}
        >
          {overline}
        </div>
      )}

      {(headline || timestamp) && (
        <div
          className={classNames(
            'flex w-full flex-col gap-spacing/gap/y-xs',
            alignClasses,
          )}
        >
          {headline && (
            <HeadingTag
              id={headingId}
              className={classNames(
                'mhg-alpha-typography-display-3 md:mhg-alpha-typography-display-2',
                textClasses.headline,
              )}
            >
              {headline}
            </HeadingTag>
          )}
          {timestamp && (
            <div
              className={classNames(
                'mhg-alpha-typography-caption',
                textClasses.body,
              )}
            >
              {timestamp}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
